
import * as enums from './Enums';

import { BillingInfoModel, CompanyRepresentativeModel } from './CompanyModel';
import { IdCardType, StoreType } from './Enums';
import { SmartListTransactionItem } from '@components/smart-list/GenericSmartList';
import { TransactionPackageModel } from './TransactionModel';
import { PackageScratchCustomerModel } from './PackageScratchCustomerModel';
import { CurrencyInfo } from '../currency-info';
import { CurrencyType } from './Enums';

export class VendorBasicModel {

    public constructor(init?: Partial<Pick<VendorBasicModel, keyof VendorBasicModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.disabledAt === 'string') {
                init.disabledAt = new Date(init.disabledAt);
            }
            Object.assign(this, init);
        }
    }

    id = 0;

    name: string;
    businessName: string;
    businessDescription: string;

    logoURL: string;
    bannerURL: string;

    email: string;

    phone: string;

    instagram: string;

    isActive: boolean;
    disabledType: enums.DisabledType;
    disabledAt?: Date;

    isAvailableInMarket: boolean;
    currencyType: enums.CurrencyType;

    createdAt: Date;

    get currencySymbol(): string {

        return CurrencyInfo.symbol(this.currencyType ?? CurrencyType.CRC);
    }
}

export class VendorModel extends VendorBasicModel {

    public constructor(init?: Partial<Pick<VendorModel, keyof VendorModel>>) {
        super(init)

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.accountFilledAt === 'string') {
                init.accountFilledAt = new Date(init.accountFilledAt);
            }
            if (typeof init.billingFilledAt === 'string') {
                init.billingFilledAt = new Date(init.billingFilledAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.disabledAt === 'string') {
                init.disabledAt = new Date(init.disabledAt);
            }
            Object.assign(this, init);
        }
    }

    id = 0;

    favIcoURL: string;
    bannerUrl: string;
    logoURL: string;
    
    accountFilledAt: Date;
    billingFilledAt: Date;
    billingResponseAt: Date = null;
    billingStatus: enums.FormStatus = enums.FormStatus.None;

    acceptNotifications: boolean;
    notificationEmail: string;
    electronicBillingEmail: string;

    locations: string;

    idCard: string;
    idCardType: number;
    commerceType: number;

    haciendaType: enums.HaciendaType;

    currencyType = enums.CurrencyType.CRC;

    updatedAt?: Date;

    allowSocialNetwork: boolean;

    province = 0;
    canton = 0;
    district = 0;

    knowsUsBy: enums.KnowsUsByType;

    sellLiquor: boolean;

    addressDetails: string;
    addressMap: string;

    billingInfo: BillingInfoModel;

    givis: SmartListTransactionItem[] | TransactionPackageModel[] | PackageScratchCustomerModel[]; // used for mygivis
}


export class VendorUserModel {

    public constructor(init?: Partial<Pick<VendorUserModel, keyof VendorUserModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.isShippingAdmin === 'string') {

                init.isShippingAdmin = `${init.isShippingAdmin}`.toLowerCase() == 'true';
            }
            if (typeof init.isActive === 'string') {

                init.isActive = `${init.isActive}`.toLowerCase() == 'true';
            }
            if (typeof init.isAdmin === 'string') {

                init.isAdmin = `${init.isAdmin}`.toLowerCase() == 'true';
            }
            Object.assign(this, init);
        }
    }

    id: number;
    vendorId: number;

    idCard: string;
    idCardType: IdCardType = IdCardType.Fisica;
    name = '';
    lastName = '';
    email: string;
    phone: string;
    birthDate: Date;

    province = 0;
    canton = 0;
    district = 0;
    address: string;

    isActive: boolean;
    disabledType: enums.DisabledType;
    disabledAt: Date;

    createdAt: Date;
    updatedAt?: Date;

    //check if URL is used?
    logoURL = '';

    vendor: VendorModel;

    //gsa values
    logoUrl = '';
    isAdmin = false;
    isShippingAdmin = false;

    vendorName: string;
    storeName: string;

    stores: VendorStoreModel[] = [];

    storeId: number;

    public get store(): VendorStoreModel {

        if (this.stores && this.stores.length) {
            return this.stores[0];
        }
        return null;
    }

    public get fullname(): string {

        return `${this.name} ${this.lastName}`.trim();
    }
}

export class VendorStoreBasicModel {

    public constructor(init?: Partial<Pick<VendorStoreBasicModel, keyof VendorStoreBasicModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    vendorId: number;
    shippingProviderId?: number;

    name = '';
    email: string;

    phone: string;
    whatsappPhone: string;
    otherPhone: string;

    logoURL = '';

    province = 0;
    canton = 0;
    district = 0;
    addressDetails: string;

    addressMap: string;

    wazeLink: string;
    googleMapLink: string;

    schedule: string;

    isActive = true;

    createdAt: Date;
    updatedAt?: Date;
}

export class VendorStoreModel extends VendorStoreBasicModel {

    public constructor(init?: Partial<Pick<VendorStoreModel, keyof VendorStoreModel>>) {
        super(init);

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (init.vendor) {
                init.vendor = new VendorBasicModel(init.vendor);
            }
            if (typeof init.mondayStartAt === 'string') {
                init.mondayStartAt = new Date(init.mondayStartAt);
            }
            if (typeof init.mondayEndAt === 'string') {
                init.mondayEndAt = new Date(init.mondayEndAt);
            }
            if (typeof init.tuesdayStartAt === 'string') {
                init.tuesdayStartAt = new Date(init.tuesdayStartAt);
            }
            if (typeof init.tuesdayEndAt === 'string') {
                init.tuesdayEndAt = new Date(init.tuesdayEndAt);
            }
            if (typeof init.wednesdayStartAt === 'string') {
                init.wednesdayStartAt = new Date(init.wednesdayStartAt);
            }
            if (typeof init.wednesdayEndAt === 'string') {
                init.wednesdayEndAt = new Date(init.wednesdayEndAt);
            }
            if (typeof init.thursdayStartAt === 'string') {
                init.thursdayStartAt = new Date(init.thursdayStartAt);
            }
            if (typeof init.thursdayEndAt === 'string') {
                init.thursdayEndAt = new Date(init.thursdayEndAt);
            }
            if (typeof init.fridayStartAt === 'string') {
                init.fridayStartAt = new Date(init.fridayStartAt);
            }
            if (typeof init.fridayEndAt === 'string') {
                init.fridayEndAt = new Date(init.fridayEndAt);
            }
            if (typeof init.saturdayStartAt === 'string') {
                init.saturdayStartAt = new Date(init.saturdayStartAt);
            }
            if (typeof init.saturdayEndAt === 'string') {
                init.saturdayEndAt = new Date(init.saturdayEndAt);
            }
            if (typeof init.sundayStartAt === 'string') {
                init.sundayStartAt = new Date(init.sundayStartAt);
            }
            if (typeof init.sundayEndAt === 'string') {
                init.sundayEndAt = new Date(init.sundayEndAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    vendorId: number;
    shippingProviderId?: number;

    name = '';
    email: string;

    phone: string;
    whatsappPhone: string;
    otherPhone: string;

    logoURL = '';

    province = 0;
    canton = 0;
    district = 0;
    addressDetails: string;

    addressMap: string;

    wazeLink: string;
    googleMapLink: string;

    schedule: string;

    isActive = true;

    createdAt: Date;
    updatedAt?: Date;
    deletedAt?: Date;

    type: StoreType;

    vendor: VendorBasicModel;

    //Schedule
    mondayStartAt: Date;
    mondayEndAt: Date;
    tuesdayStartAt: Date;
    tuesdayEndAt: Date;
    wednesdayStartAt: Date;
    wednesdayEndAt: Date;
    thursdayStartAt: Date;
    thursdayEndAt: Date;
    fridayStartAt: Date;
    fridayEndAt: Date;
    saturdayStartAt: Date;
    saturdayEndAt: Date;
    sundayStartAt: Date;
    sundayEndAt: Date;
}

export class ProfileImageModel {

    public constructor(init?: Partial<Pick<ProfileImageModel, keyof ProfileImageModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    vendorId: number;

    name = '';
    url = '';
    thumbnailUrl = '';
    type: enums.VendorProfileImageType;

    createdAt: Date;
    updatedAt: Date;

}

export class VendorStoreCustomer {

    public constructor(init?: Partial<Pick<VendorStoreCustomer, keyof VendorStoreCustomer>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    vendorId: number;
    
    logoUrl: string;
    vendorName: string;

    storeId: number;
    storeName: string;
    isAdmin = false;
    isShippingAdmin = false;
    storeShippingProviderId: number;
    country = enums.Country.CR;

    zebraScan = false;
    fastScan = false;
}
